import React from 'react';
import { BiArrowBack } from 'react-icons/bi';
import { IButton } from '../../../interfaces/components/button.interface';

const BackBtn: React.FC<IButton> = ({
  callback,
  // theme = 'dark',
  size,
}) => {
  return (
    <main>
      {/* mobile */}
      <div className="sm:hidden my-6 text-xl flex items-center">
        <button onClick={callback}>
          <BiArrowBack color="#979797" className="cursor-pointer" size={size} />
        </button>
      </div>
      {/* desktop */}
      <div
        onClick={callback}
        className={`hidden sm:block cursor-pointer rounded-full p-3 opacity-50 hover:opacity-100 bg-white`}
      >
        <div className="opacity-100">
          <BiArrowBack color="black" size={size} />
        </div>
      </div>
    </main>
  );
};

export default BackBtn;
